import { Account } from '@/domain/usecases'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import { upgradeRequestService } from '@/data/services/upgrade/upgrade-service'
import CompanyManagerBaseLoader from '../../company-manager-base-loader'

export default class CompanyManagerUpgradeRequestLoader extends CompanyManagerBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(account, undefined, queryClient, ldClient)
  }

  async loader() {
    const [upgradeSettings] = await Promise.all([
      upgradeRequestService.fetchSettings(this.account.company.uniqueId)
    ])

    const response = {
      ...upgradeSettings
    }

    return this.defer({ data: response })
  }
}
